import styled, { css } from 'styled-components';

type ToggleListStylesProps = {
  type: string;
};

export const ToggleListStyles = styled.div<ToggleListStylesProps>`
  // normal option
  padding: 12px;
  border-left: 1px solid lightgray;
  flex: 1;
  .toggle__option__container {
    user-select: none;
    cursor: pointer;
    transition: all ease 250ms;
    &:hover {
      background-color: var(--primary-lightGray);
    }
    max-width: 280px;
    height: 55px;
    display: flex;
    align-items: center;
    .image__container {
      display: flex;
      justify-content: center;
      width: 20%;
      .image {
        height: 34px;
        width: 34px;
        object-fit: cover;
        border-radius: 100%;
        border: 1px solid lightGray;
      }
    }
    .right__container {
      flex: 1;
      align-items: center;
      height: 100%;
      border-bottom: 1px solid lightGray;
      display: flex;
      .text {
        padding: 0px 20px 0px 20px;
        flex: 1;
      }
      .icon__container {
        padding-right: 20px;
      }
    }
  }
  // material color option
  ${(props) => {
    return props.type === 'colorOption'
      ? css`
          padding: 12px;
          border-left: 1px solid lightgray;
          align-items: center;
          display: flex;
          flex-wrap: wrap;
          .toggle__option__container {
            position: relative;
            .tooltip {
              position: absolute;
              display: none;
              bottom: -30px;
              left: 50%;
              transform: translateX(-50%);
              padding: 0 8px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              color: white;
              background-color: rgba(0, 0, 0, 0.7);
              border-radius: 20px;
              z-index: 1;
            }
            &:hover {
              .tooltip {
                display: block;
              }
            }
            user-select: none;
            cursor: pointer;
            transition: all ease 250ms;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 33.33%;
            aspect-ratio: 1/1;
            .color__container {
              border: 1px solid lightGray;
              width: 34px;
              aspect-ratio: 1/1;
              > .icon__check__container {
                width: 100%;
                height: 100%;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                > .icon__check {
                  background-color: #006b67;
                  border-radius: 50%;
                  padding: 2px;
                  display: inline-block;
                  border: 1px solid lightgray;
                  color: lightgray;
                }
              }
              .input__color {
                width: 100%;
                height: 100%;
                outline: none;
                border: none;
              }
            }
          }
          .inputColorContainer {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            .label__color__input {
              width: 90px;
              min-width: 90px;
              padding-left: 10px;
            }
            .colorInput {
              width: 100px;
              margin-right: 10px;
              outline: none;
            }
            .btn__apply__color {
              cursor: pointer;
              border-radius: 4px;
              border: none;
              padding: 3px 6px;
              background-color: #006b67;
              color: white;
            }
          }
          .color__reference {
            padding-top: 4px;
            width: 100%;
            > a {
              display: inline-block;
              width: 100%;
              color: #006b67;
              font-size: 13px;
              text-align: right;
            }
          }
        `
      : css``;
  }}
  ${(props) =>
    props.type === 'imageOption-3'
      ? css`
          padding: 12px;
          border-left: 1px solid lightgray;
          align-items: center;
          display: flex;
          flex-wrap: wrap;
          .toggle__option__container {
            position: relative;
            .tooltip {
              position: absolute;
              display: none;
              padding: 0 8px;
              bottom: -30px;
              left: 0px;
              left: 50%;
              transform: translateX(-50%);
              height: 30px;
              line-height: 30px;
              text-align: center;
              color: white;
              background-color: rgba(0, 0, 0, 0.7);
              border-radius: 20px;
              z-index: 1;
            }
            &:hover {
              .tooltip {
                display: block;
              }
            }
            user-select: none;
            cursor: pointer;
            transition: all ease 250ms;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 33.33%;
            aspect-ratio: 1/1;
            .image__container {
              position: relative;
              border: 1px solid lightGray;
              width: 40px;
              aspect-ratio: 1/1;
              > image {
                height: 100%;
                width: 100%;
                object-fit: cover;
              }
              > .icon__check__container {
                position: absolute;
                width: 100%;
                height: 100%;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                > .icon__check {
                  background-color: #006b67;
                  border-radius: 50%;
                  padding: 2px;
                  display: inline-block;
                  border: 1px solid lightgray;
                  color: lightgray;
                }
            }
          }
        `
      : css``};
  ${(props) =>
    props.type === 'toggle-1'
      ? css`
          .toggle__option__container {
            justify-content: space-between;
            padding: 0 12px;
            &:hover {
              cursor: auto;
            }
            .right__container__toggle {
              width: 100%;
              display: flex;
              justify-content: space-between;
              .toggle__status {
                cursor: pointer;
              }
              .toggle__status {
              }
            }
          }
        `
      : css``};
  ${(props) =>
    props.type === 'multi-dropdown'
      ? css`
          > .toggle__container__value {
            width: 100%;
            display: flex;
            justify-content: space-between;
            max-width: 280px;
            padding: 0px 12px;
            height: 55px;
            .all__check {
              user-select: none;
              cursor: pointer;
              display: flex;
              align-items: center;
              > i {
                font-size: 29px;
              }
            }
          }
          .toggle__option__container {
            justify-content: space-between;
            padding: 0 12px;
            &:hover {
              cursor: auto;
            }
            .toggle__container__value {
              width: 100%;
              display: flex;
              justify-content: space-between;
              .input__checkbox {
                width: 25px;
                height: 25px;
                cursor: pointer;
              }
            }
          }
        `
      : css``};
`;
